var map = {
	"./C++.svg": 5666,
	"./CSS3.svg": 5861,
	"./HTML5.svg": 5380,
	"./LISTR.webm": 8271,
	"./android.svg": 1924,
	"./catan_board.webp": 2176,
	"./clouds.webp": 2026,
	"./forest.webp": 3684,
	"./forest_depth.jpg": 1697,
	"./github.svg": 2905,
	"./java.svg": 3400,
	"./javascript.svg": 3629,
	"./linkedin.svg": 6167,
	"./logo.webp": 9715,
	"./me.webp": 3531,
	"./minesweeper.webp": 2621,
	"./mountain-front.svg": 430,
	"./mountain-rear.svg": 7285,
	"./node.svg": 8890,
	"./python.svg": 3011,
	"./snapceit.webp": 4903,
	"./tensorflow.svg": 751,
	"./toph.webp": 2143,
	"./tree.svg": 6647,
	"./ucalgary.svg": 2110,
	"./vue.svg": 600,
	"./youtube.svg": 7698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;